var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronLeft = function SvgChevronLeft(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-343 -2983C-343 -3038.23 -298.228 -3083 -243 -3083H31783C31838.2 -3083 31883 -3038.23 31883 -2983V8887C31883 8942.23 31838.2 8987 31783 8987H-243C-298.229 8987 -343 8942.23 -343 8887V-2983Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-243 -3082H31783V-3084H-243V-3082ZM31882 -2983V8887H31884V-2983H31882ZM31783 8986H-243V8988H31783V8986ZM-342 8887V-2983H-344V8887H-342ZM-243 8986C-297.676 8986 -342 8941.68 -342 8887H-344C-344 8942.78 -298.781 8988 -243 8988V8986ZM31882 8887C31882 8941.68 31837.7 8986 31783 8986V8988C31838.8 8988 31884 8942.78 31884 8887H31882ZM31783 -3082C31837.7 -3082 31882 -3037.68 31882 -2983H31884C31884 -3038.78 31838.8 -3084 31783 -3084V-3082ZM-243 -3084C-298.781 -3084 -344 -3038.78 -344 -2983H-342C-342 -3037.68 -297.676 -3082 -243 -3082V-3084Z",
    fill: "black",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 900,
    transform: "translate(-19 -90)",
    fill: "#F2F2F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 244,
    height: 900,
    transform: "translate(-19 -90)",
    fill: "#F2F2F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -10,
    width: 226,
    height: 44,
    rx: 22,
    fill: "#E4E4E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17L10 12L15 7",
    stroke: "#797979",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeft);
export default ForwardRef;